import { ChangeDetectionStrategy, Component, HostBinding, computed, inject } from '@angular/core';
import { FormFeatureDirective } from '../form-feature.directive';
import { GridComponent } from '../../../grid/grid.component';
import { HeadingComponent } from '../../../heading/heading.component';
import { TextHtmlParagraphComponent } from '../../../text-html/text-html-paragraph.component';

import { AnchorDirective } from '../../../_shared/directives/anchor.directive';
import { SECTION_SURFACE } from '../../../section/section-surface';

@Component({
    selector: 'sirius-form-feature-base',
    templateUrl: './form-feature-base.component.html',
    styleUrls: ['./form-feature-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    GridComponent,
    HeadingComponent,
    TextHtmlParagraphComponent,
    AnchorDirective
]
})
export class FormFeatureBaseComponent extends FormFeatureDirective {
    private readonly _sectionSurface = inject(SECTION_SURFACE, { optional: true });

    // The embedded form is a cross-origin iframe we can't restyle, so on dark it sits on a light panel.
    protected readonly hasPanel = computed(() => this._sectionSurface?.surfaceMode() === 'dark');

    @HostBinding('class.one-column')
    get hasNoText(): boolean {
        return this.title.trim().length === 0 && this.textHtml.trim().length === 0;
    }

    constructor() {
        super();
    }
}
